import { render, staticRenderFns } from "./TagHeatmapMobile.vue?vue&type=template&id=59a836e1&scoped=true"
import script from "./TagHeatmapMobile.vue?vue&type=script&lang=js"
export * from "./TagHeatmapMobile.vue?vue&type=script&lang=js"
import style0 from "./TagHeatmapMobile.vue?vue&type=style&index=0&id=59a836e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a836e1",
  null
  
)

export default component.exports